import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Stats from "./components/Stats";
import Clients from "./components/Clients";
import Testimonials from "./components/Testimonials";
import Team from "./components/Team";
import Blog from "./components/Blog";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import '@mdi/font/css/materialdesignicons.min.css';

export default function App() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="app-shell">
      <Navbar scrolled={scrolled} />
      <Hero />
      <About />
      <Services />
      <Stats />
      {/* <Clients /> */}
      {/* <Testimonials /> */}
      <Team />
      {/* <Blog /> */}
      <Contact />
      <Footer />
    </div>
  );
}
